(() => {
  if (window.__hartaraGalleryStableV9) return;
  window.__hartaraGalleryStableV9 = true;

  const PDP_SELECTOR = '.hartara-pdp';
  const MEDIA_TOGGLE_SELECTOR =
    '.hartara-pdp .product__media-toggle[data-media-id]';
  const PREV_SELECTOR = '[data-hartara-gallery-previous]';
  const NEXT_SELECTOR = '[data-hartara-gallery-next]';

  let lightbox;
  let viewport;
  let image;
  let lastTrigger = null;

  const clamp = (value, min, max) =>
    Math.min(Math.max(value, min), max);

  const ensureLightbox = () => {
    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'hartara-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Imagen ampliada');

    lightbox.innerHTML = `
      <button
        type="button"
        class="hartara-lightbox__close"
        aria-label="Cerrar"
      >×</button>
      <div class="hartara-lightbox__viewport">
        <img class="hartara-lightbox__image" alt="">
      </div>
    `;

    document.body.appendChild(lightbox);

    viewport = lightbox.querySelector('.hartara-lightbox__viewport');
    image = lightbox.querySelector('.hartara-lightbox__image');

    lightbox
      .querySelector('.hartara-lightbox__close')
      .addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    image.addEventListener('click', (event) => {
      event.preventDefault();

      if (lightbox.classList.contains('is-zoomed')) {
        resetZoom();
        return;
      }

      zoomImage(event.clientX, event.clientY);
    });

    return lightbox;
  };

  const getBestImageSource = (toggle) => {
    const mediaItem = toggle.closest('[data-media-id]');
    const sourceImage =
      mediaItem?.querySelector('.product__media img') ||
      mediaItem?.querySelector('img');

    if (!sourceImage) return null;

    return {
      src:
        sourceImage.currentSrc ||
        sourceImage.src ||
        sourceImage.getAttribute('src'),
      alt: sourceImage.alt || '',
      naturalWidth: sourceImage.naturalWidth || 0,
    };
  };

  const resetZoom = () => {
    if (!lightbox || !image || !viewport) return;

    lightbox.classList.remove('is-zoomed');
    image.style.removeProperty('--hartara-lightbox-zoom-width');
    viewport.scrollTo({ left: 0, top: 0, behavior: 'auto' });
  };

  const openLightbox = (toggle) => {
    const source = getBestImageSource(toggle);
    if (!source?.src) return;

    ensureLightbox();
    resetZoom();

    image.src = source.src;
    image.alt = source.alt;
    image.dataset.naturalWidth = String(source.naturalWidth || '');

    lastTrigger = toggle;
    lightbox.setAttribute('open', '');
    document.body.classList.add('hartara-lightbox-open');

    requestAnimationFrame(() => {
      lightbox.querySelector('.hartara-lightbox__close')?.focus();
    });
  };

  const closeLightbox = () => {
    if (!lightbox) return;

    resetZoom();
    lightbox.removeAttribute('open');
    document.body.classList.remove('hartara-lightbox-open');
    lastTrigger?.focus?.();
  };

  const zoomImage = (clientX, clientY) => {
    if (!lightbox || !viewport || !image) return;

    const rect = image.getBoundingClientRect();
    const xRatio = clamp(
      (clientX - rect.left) / Math.max(rect.width, 1),
      0,
      1
    );
    const yRatio = clamp(
      (clientY - rect.top) / Math.max(rect.height, 1),
      0,
      1
    );

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const factor = isMobile ? 2.2 : 1.9;
    const naturalWidth =
      image.naturalWidth ||
      Number(image.dataset.naturalWidth) ||
      rect.width * factor;

    const targetWidth = Math.max(
      rect.width * factor,
      Math.min(naturalWidth, window.innerWidth * (isMobile ? 1.7 : 1.4))
    );

    image.style.setProperty(
      '--hartara-lightbox-zoom-width',
      `${Math.round(targetWidth)}px`
    );
    lightbox.classList.add('is-zoomed');

    requestAnimationFrame(() => {
      const left =
        image.offsetLeft +
        image.offsetWidth * xRatio -
        viewport.clientWidth / 2;
      const top =
        image.offsetTop +
        image.offsetHeight * yRatio -
        viewport.clientHeight / 2;

      viewport.scrollTo({
        left: Math.max(0, left),
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    });
  };

  const getGalleryItems = (gallery) => {
    const viewer = gallery.querySelector('[id^="Slider-Gallery"]');

    return Array.from(viewer?.children || []).filter(
      (item) =>
        item.hasAttribute('data-media-id') &&
        !item.hidden
    );
  };

  const moveGallery = (button, direction) => {
    const gallery = button.closest('media-gallery');
    if (!gallery) return;

    const items = getGalleryItems(gallery);
    if (items.length < 2) return;

    let currentIndex = items.findIndex((item) =>
      item.classList.contains('is-active')
    );

    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      (currentIndex + direction + items.length) % items.length;
    const nextItem = items[nextIndex];
    const mediaId = nextItem.dataset.mediaId;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
      return;
    }

    const matchingThumbnail = gallery.querySelector(
      `[data-target="${CSS.escape(mediaId)}"] button`
    );
    matchingThumbnail?.click();
  };

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest(MEDIA_TOGGLE_SELECTOR);
      if (!toggle) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openLightbox(toggle);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const previous = event.target.closest(PREV_SELECTOR);
    const next = event.target.closest(NEXT_SELECTOR);

    if (!previous && !next) return;

    event.preventDefault();
    event.stopPropagation();

    moveGallery(previous || next, previous ? -1 : 1);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && lightbox?.hasAttribute('open')) {
      closeLightbox();
    }
  });

  const initialize = () => {
    if (!document.querySelector(PDP_SELECTOR)) return;
    ensureLightbox();
  };

  document.addEventListener('shopify:section:load', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
